



















import { computed, defineComponent } from "@vue/composition-api";
import { alarm } from "@/store";
export default defineComponent({
    components: {
        EnabledDisabled: () =>
            import("./Sensors/EnabledDisabledItem.vue")
    },
    setup() {
        const immobilizerEnabled = computed<boolean>(() => {
            return alarm.armed;
        });
        const geoFenceEnabled = computed<boolean>(() => {
            return alarm.armed;
        });

        return { immobilizerEnabled, geoFenceEnabled };
    }
});
